"use client";
import * as React from 'react';
import { wrapper } from './styles.js';
import { colors } from '../../constants/colors.js';

var WidgetWrapper = function WidgetWrapper(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === undefined ? colors.snowWhite : _ref$backgroundColor,
    _ref$foregroundColor = _ref.foregroundColor,
    foregroundColor = _ref$foregroundColor === undefined ? colors.inkGrey : _ref$foregroundColor,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === undefined ? colors.oceanGreen : _ref$hoverColor,
    _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === undefined ? colors.oceanGreen : _ref$highlightColor,
    children = _ref.children;
  var colorProps = {
    backgroundColor: backgroundColor,
    foregroundColor: foregroundColor,
    hoverColor: hoverColor,
    highlightColor: highlightColor
  };
  return /*#__PURE__*/React.createElement(wrapper, null, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, colorProps) : child;
  }));
};

export { WidgetWrapper };
